import { type Brand } from '@/modules/cms/types';
import { type ProductBySlugResponse } from '@/modules/product/aliases';

export function getProductBreadcrumbsBrand(
  product?: ProductBySlugResponse
): Brand | undefined {
  const brandSlug = product?.attributes?.brand;

  return product?.brand_id && product.brand_name && brandSlug
    ? { id: product.brand_id, name: product.brand_name, slug: brandSlug }
    : undefined;
}
